import React from 'react'
import { Tab } from 'semantic-ui-react'
import IndexBank from './_userbank/IndexBank';
import IndexOPD from './_useropd/IndexOPD';
import IndexVerificator from './_userverificator/IndexVerificator';

const panes = [
   { 
      menuItem: 'Users OPD', 
      render: () => <Tab.Pane attached={false}><IndexOPD /></Tab.Pane> 
   },
   { 
      menuItem: 'Users Bank', 
      render: () => <Tab.Pane attached={false}><IndexBank /></Tab.Pane> 
   },
   { 
      menuItem: 'Users Verificator', 
      render: () => <Tab.Pane attached={false}><IndexVerificator /></Tab.Pane> 
   },
]

const Users = () => (
  <Tab menu={{ pointing: true }} panes={panes} />
)

export default Users;


// WEBPACK FOOTER //
// ./src/components/Content/views/admin/_user/Users.js